import { Facebook, Instagram, Phone, Mail } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

export default function Footer() {
  const bookingUrl = typeof window !== "undefined" ? `${window.location.origin}/book` : "https://1motionelitetransport.com/book";

  return (
    <footer data-testid="main-footer" className="bg-[#030710] border-t border-[#1a2838] pt-20 pb-10 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
        <div>
          <img src="/images/logo-original.png" alt="1Motion Elite Transport" className="h-12 mb-5"/>
          <p className="text-sm text-[#6b7c8a] leading-relaxed">
            Luxury in Motion — professionalism with personality. Caribbean charm meets world-class service.
          </p>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="tel:9544514424" className="flex items-center gap-2 text-[#f0f6fb] hover:text-[#5DCFE5]"><Phone size={14}/> 954-451-4424</a></li>
            <li><a href="mailto:1motionelitetransport@gmail.com" className="flex items-center gap-2 text-[#f0f6fb] hover:text-[#5DCFE5]"><Mail size={14}/> 1motionelitetransport@gmail.com</a></li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Follow</h4>
          <div className="flex gap-3">
            <a href="https://www.facebook.com/profile.php?id=61577593806805" target="_blank" rel="noreferrer" data-testid="footer-fb" className="w-10 h-10 rounded-full border border-[#1a2838] hover:border-[#5DCFE5] flex items-center justify-center text-[#f0f6fb] hover:text-[#5DCFE5] transition"><Facebook size={16}/></a>
            <a href="https://www.instagram.com/1motionelitetransport" target="_blank" rel="noreferrer" data-testid="footer-ig" className="w-10 h-10 rounded-full border border-[#1a2838] hover:border-[#5DCFE5] flex items-center justify-center text-[#f0f6fb] hover:text-[#5DCFE5] transition"><Instagram size={16}/></a>
            <a href="https://www.tiktok.com/@1motionelitetransport" target="_blank" rel="noreferrer" data-testid="footer-tt" className="w-10 h-10 rounded-full border border-[#1a2838] hover:border-[#5DCFE5] flex items-center justify-center text-[#f0f6fb] hover:text-[#5DCFE5] transition text-[11px] font-bold">TT</a>
          </div>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Scan to Book</h4>
          <div className="bg-[#f0f6fb] p-3 rounded-lg inline-block" data-testid="footer-qr">
            <QRCodeSVG value={bookingUrl} size={110} bgColor="#f0f6fb" fgColor="#050a12" level="M"/>
          </div>
          <p className="text-[11px] text-[#6b7c8a] mt-2 leading-snug max-w-[140px]">Scan with your phone to start booking</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-6 border-t border-[#1a2838] flex flex-col md:flex-row justify-between gap-4 text-xs text-[#4a5868]">
        <div>© {new Date().getFullYear()} 1Motion Elite Transport. All rights reserved.</div>
        <div className="tracking-[0.2em] uppercase">Professionalism with Personality</div>
      </div>
    </footer>
  );
}
